import * as CONST from '../ActionTypes';
import * as util from './util';

/**
 * 都道府県一覧取得
 */
// eslint-disable-next-line import/prefer-default-export
export const getPrefList = () => (dispatch) => fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/prefectures`, {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  mode: 'cors',
})
  .then((response) => response.json())
  .then((payload) => {
    dispatch(util.actionType(CONST.GET_PREF_LIST_SUCCESS, payload));
  })
  .catch((error) => {
    dispatch(util.actionType(CONST.GET_PREF_LIST_FAILURE, error));
  });
